$(window).on('load', function() {
  setTimeout(function () {
    $('body').addClass('is-transition');
  }, 50);
});
